<template>
  <footer class="l-footer">
    <div class="l-footer-container l-main_container">
      <nav class="l-footer_menu">
        <ul>
          <li class="l-footer_menu-item">
            <span class="l-footer_menu-item_num">01.</span>
            <router-link to="/works" class="l-footer_menu-item_link">
              <span class="l-footer_menu-item_link-text" data-splitting>Works</span>
              <span class="l-footer_menu-item_link-text" data-splitting>Works</span>
              <span class="l-footer_menu-item_link-arrow"></span>
            </router-link>
          </li>
          <li class="l-footer_menu-item">
            <span class="l-footer_menu-item_num">02.</span>
            <router-link to="/about" class="l-footer_menu-item_link">
              <span class="l-footer_menu-item_link-text" data-splitting>About</span>
              <span class="l-footer_menu-item_link-text" data-splitting>About</span>
              <span class="l-footer_menu-item_link-arrow"></span>
            </router-link>
          </li>
          <!-- <li class="l-footer_menu-item">
            <span class="l-footer_menu-item_num">03.</span>
            <router-link to="/about" class="l-footer_menu-item_link">
              <span class="l-footer_menu-item_link-text" data-splitting>Sandbox</span>
              <span class="l-footer_menu-item_link-text" data-splitting>Sandbox</span>
              <span class="l-footer_menu-item_link-arrow"></span>
            </router-link>
          </li> -->
          <li class="l-footer_menu-item">
            <span class="l-footer_menu-item_num">03.</span>
            <a href="https://www.facebook.com/sho.iwatate" target="_blank" class="l-footer_menu-item_link">
              <span class="l-footer_menu-item_link-text" data-splitting>Contact</span>
              <span class="l-footer_menu-item_link-text" data-splitting>Contact</span>
              <span class="l-footer_menu-item_link-arrow"></span>
            </a>
          </li>
        </ul>
      </nav>
      <div class="l-footer_copy">&copy;{{thisYear}} iwatate</div>
    </div>
  </footer>
</template>

<script>
import Splitting from "splitting";
export default {
  name: 'Navigation-Footer',
  mounted() {
    Splitting();
  },
  data() {
    return {
      thisYear: new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="scss">
@use "../assets/style/_footer.scss";
</style>
